var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 844,
    viewBox: "0 0 390 844",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_1487)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_116_1487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 96.5,
    rx: 150,
    ry: 146.5,
    fill: "#BA93FA"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_116_1487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 352,
    cy: 96.5,
    rx: 150,
    ry: 146.5,
    fill: "#FADD93"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_116_1487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 299,
    cy: 670.5,
    rx: 150,
    ry: 146.5,
    fill: "#C793FA"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_116_1487)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 490.5,
    rx: 150,
    ry: 146.5,
    fill: "#FAEA93"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_116_1487",
    x: -291.8,
    y: -203.8,
    width: 607.6,
    height: 600.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.9,
    result: "effect1_foregroundBlur_116_1487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_116_1487",
    x: 48.2,
    y: -203.8,
    width: 607.6,
    height: 600.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.9,
    result: "effect1_foregroundBlur_116_1487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_116_1487",
    x: -4.8,
    y: 370.2,
    width: 607.6,
    height: 600.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.9,
    result: "effect1_foregroundBlur_116_1487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_116_1487",
    x: -294.8,
    y: 190.2,
    width: 607.6,
    height: 600.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.9,
    result: "effect1_foregroundBlur_116_1487"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_1487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.77e2b3396c4f5bee2094050107410219.svg";
export { ForwardRef as ReactComponent };